module.exports = __webpack_public_path__ + "img/result_bg.b231d307.png";